import * as React from 'react'
import { SVGProps } from 'react'
const SvgCompass = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#compass_svg__a)" fillRule="evenodd" clipRule="evenodd" fill="currentColor">
      <path d="M33.912 16.331a1.773 1.773 0 0 0-2.24-2.24l-12.345 4.112a1.773 1.773 0 0 0-1.122 1.121L14.09 31.67a1.773 1.773 0 0 0 2.241 2.24l12.345-4.114a1.772 1.772 0 0 0 1.121-1.122l4.115-12.344v.002ZM18.575 29.428l2.712-8.141 8.14-2.712-2.711 8.14-8.141 2.713Z" />
      <path d="M24 45c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21Zm0 3c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z" />
    </g>
    <defs>
      <clipPath id="compass_svg__a">
        <path fill="currentColor" d="M0 0h48v48H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgCompass
